<div >
    <div class="row ">
        <div class="col ps-3">
            <h4 class="mb-0 font-header-1 mb-2 " style="font-weight: 700;">Admin Time</h4>
        </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col">
            <div widget class="card border-0 box-shadow ps-3 ">
                <div class="mt-2">
                    <div class="row mt-2">
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">From <sup class="super-script">*</sup></label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptions" [selDate]="ListStartDate"
                                    placeholder="mm/dd/yyyy" id="ATListListStartDate"
                                    (inputFieldChanged)="ATNewdates($event,'inputchanged','Start')"
                                    (dateChanged)="ATNewdates($event,'datechanged','Start')">
                                </my-date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">To<sup class="super-script">*</sup></label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptions" [selDate]="ListEndDate"
                                    placeholder="mm/dd/yyyy" id="ATListListEndDate"
                                    (inputFieldChanged)="ATNewdates($event,'inputchanged','End')"
                                    (dateChanged)="ATNewdates($event,'datechanged','End')">
                                </my-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Employee </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [(ngModel)]="ListEmployeeId" [searchable]="true" [clearable]="true"
                                    [items]="EmployeeDropDown" bindLabel="Value" bindValue="Key" id="ATListListEmployeeId">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2  ">
                        <div class="col-lg-6 ">
                            <button class="btn btn-sm " (click)="EmitToAtEntry()" id="ATListEmitToAtEntry">Add
                                AdminTime Entry</button>
                                <button type="button" class="btn btn-sm ms-2" (click)="printAspdf()"
                                [disabled]="!isDataAvailableToPrint"
                               >Print</button>
                            <button type="button" class="btn btn-sm ms-2" (click)="exportAsExcel()" id="ATListexportAsExcel"
                                [disabled]="!isDataAvailableToPrint">Export as Excel</button>

                                
                        </div>
                        <div class="col-lg-6 text-end">
                            <button type="button" class="btn btn-sm" (click)="ApplyFilter()" id="ATListApplyFilter">Apply
                            </button>
                            <button class="btn btn-sm ms-2 me-3" (click)="Refresh()" id="ATListRefresh"
                                [disabled]="this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"><i _ngcontent-lep-c69=""
                                    class="fa fa-repeat">&nbsp;</i>Refresh</button>
                        </div>
                    </div>
                    <div class="row mt-2  pe-3">
                        <div class="col-lg-12 ">
                            <div class="control-section">
                                <ejs-grid #gridAT [dataSource]='data | async' [allowResizing]='true'
                                    [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                                    [pageSettings]='initialPage' (actionComplete)="onActionComplete($event)"
                                    (dataStateChange)='dataStateChange($event)' [filterSettings]='filterOptions'
                                    [showColumnChooser]='true' (resizeStop)="onResize($event)">
                                    <e-columns>
                                        <!-- Action -->
                                        <e-column uid='action' headerText="Actions" minWidth=100
                                            [showInColumnChooser]='false' textAlign='center' [allowEditing]='false'
                                            [allowFiltering]="false" [allowSorting]='false'>
                                            <ng-template #template let-data>
                                                <button class="btn btn-edit-table Ationsubbtn" id="ATListenableedit"
                                                    data-bs-target="#updateAdminTime" data-bs-toggle="modal"
                                                    (click)="EditAT(data)"><i class="fa fa-edit"></i></button>
                                                <button data-bs-target="#deleteAdminTime" data-bs-toggle="modal"
                                                    class="btn btn-delete-table ms-2" id="ATListdelTime"
                                                    (click)="deleteList.adminTime_id=data.id">
                                                    <i class="fa fa-trash fa-lg"></i></button>
                                                <button class="btn  btn-sm ms-2" data-bs-toggle="modal"
                                                    data-bs-target="#shownotes" (click)="shownotesdescription(data)" id="ATListdescription"
                                                    [style.backgroundColor]="(data.notes!='' && data.notes!=undefined && data.notes!=null)?'GREEN':'#007bff'">
                                                    <i class="fa fa-file-text-o" aria-hidden="true"
                                                        style="color:white"></i>
                                                </button>
                                            </ng-template>

                                        </e-column>
                                        <!-- Employee -->
                                        <e-column field="employeeName" headerText="Employee" minWidth="140"
                                            type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <!-- Date -->
                                        <e-column field='date' minWidth="100" headerText='Date' textAlign='left'
                                            [allowEditing]='false' type='date' [allowFiltering]='false'
                                            [format]='formatOptions'>
                                        </e-column>
                                        <!-- In -->
                                        <e-column field='inTime' minWidth="100" headerText='In' textAlign='left'
                                            [allowEditing]='false' type='date' [allowFiltering]='false'
                                            [format]='datetimeformatoption'>
                                        </e-column>
                                        <!-- Out -->
                                        <e-column field='outTime' minWidth="100" headerText='Out' textAlign='left'
                                            [allowEditing]='false' type='date' [allowFiltering]='false'
                                            [format]='datetimeformatoption'>
                                        </e-column>
                                        <!-- Total Hours -->
                                        <e-column field='totalhours' minWidth="100" headerText='Total Hours'
                                            textAlign='left' [allowEditing]='false' type="number">
                                        </e-column>
                                        <e-column field="entryTypeName" headerText="Entry Type" minWidth="140"
                                            type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <!-- setting -->
                                        <e-column width="50" [showInColumnChooser]='false'>
                                            <ng-template #headerTemplate let-data>
                                                <div class="d-none d-lg-block">
                                                    <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg"
                                                            aria-hidden="true">
                                                        </i></span>
                                                </div>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                    <e-aggregates>
                                        <e-aggregate>
                                            <e-columns>

                                                <e-column field='totalhours' type="Sum" 
                                                format="C2">
                                                    <ng-template #footerTemplate let-data>Total
                                                        Hours:
                                                        {{totalhoursSummaryMinutes}}</ng-template>
                                                </e-column>

                                            </e-columns>
                                        </e-aggregate>
                                    </e-aggregates>
                                </ejs-grid>
                            
                                <div *ngIf="ATList.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- update Admin Time -->
<span data-bs-target="#updateAdminTime" data-bs-toggle="modal" id="UpdateModal"></span>
<div class="modal fade " id="updateAdminTime" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Update Admin Time</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="ATListupdateadmintime">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <!-- Employee -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">Employee<sup class="super-script">&nbsp; *</sup>
                            </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="updateAdminTimeNonBillable.employeeId" [searchable]="true" id="ATListemployeeId"
                                [clearable]="true" [items]="ListATInputProperty.EmployeeDropDown " bindLabel="Value"
                                bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Date -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">Date<sup class="super-script">&nbsp; *</sup>
                            </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="updateAdminTimeNonBillable.date"
                                placeholder="mm/dd/yyyy" id="ATListATNewdates"
                                (inputFieldChanged)="ATNewdates($event,'inputchanged','updateDate')"
                                (dateChanged)="ATNewdates($event,'datechanged','updateDate')">
                            </my-date-picker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- In -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">In<sup class="super-script">&nbsp; *</sup>
                            </label>
                        </div>
                        <div class="col-lg-12">

                            <input type="time" class="form-control" [(ngModel)]="updateAdminTimeNonBillable.inTime"
                                [disabled]="updateAdminTimeNonBillable.date==null ||
                            updateAdminTimeNonBillable.date==undefined || updateAdminTimeNonBillable.date==''"
                                (ngModelChange)="HoursCalculation()" id="ATListinTime">
                        </div>
                    </div>
                    <!-- Out -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">Out<sup class="super-script">&nbsp; *</sup>
                            </label>
                        </div>
                        <div class="col-lg-12">
                            <input type="time" class="form-control" [(ngModel)]="updateAdminTimeNonBillable.outTime"
                                [disabled]="updateAdminTimeNonBillable.date==null ||
                            updateAdminTimeNonBillable.date==undefined || updateAdminTimeNonBillable.date==''"
                                (ngModelChange)="HoursCalculation()" id="ATListoutTime">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Hour -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">
                                Hour<sup class="super-script">&nbsp; *</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="updateAdminTimeNonBillable.totalhours" id="ATListtotalhours"
                                disabled>
                        </div>
                    </div>
                    <!-- Notes -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">Entry Type</label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="updateAdminTimeNonBillable.entryTypeLid" [searchable]="true" [clearable]="true"
                            [items]="EditEntryTypeList" bindLabel="lovName" bindValue="id" id="ATListListListEditEntryTypeLid">
                        </ng-select>                        
                    </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label me-0 ms-3">Notes</label>
                        </div>
                        <div class="col-lg-12">
                            <textarea type="text" class="form-control"[(ngModel)]="updateAdminTimeNonBillable.notes" id="ATListnotes">
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-lg-12">
                        <button class="btn btn-sm" (click)="updateAt()" id="ATListupdateAt"
                            [disabled]="updateAdminTimeNonBillable.totalhours==0||
                        updateAdminTimeNonBillable.totalhours==null || updateAdminTimeNonBillable.totalhours==undefined ||
                        updateAdminTimeNonBillable.employeeId==null || updateAdminTimeNonBillable.employeeId==undefined || updateAdminTimeNonBillable.employeeId=='00000000-0000-0000-0000-000000000000'||
                        updateAdminTimeNonBillable.date==null || updateAdminTimeNonBillable.date==undefined ||updateAdminTimeNonBillable.date==''||
                        updateAdminTimeNonBillable.inTime==null || updateAdminTimeNonBillable.inTime==undefined || updateAdminTimeNonBillable.inTime==''||
                        updateAdminTimeNonBillable.outTime==null || updateAdminTimeNonBillable.outTime==undefined || updateAdminTimeNonBillable.outTime==''">
                            Update & Close
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-sm" data-bs-dismiss="modal" id="ATListupdateAtbtn">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- .Delete -->
<span data-bs-target="#deleteAdminTime" data-bs-toggle="modal" id="delete"></span>
<div class="modal fade " id="deleteAdminTime" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete AdminTime</h5>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPass">
                    <div class="row">
                        <div class="col-lg-2">
                            <label style="font-weight: 600;margin-top:6px;">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password" id="ATListPassword"
                                [(ngModel)]="deleteList.password" (keyup)="passvalid($event)">
                            <div *ngIf="resetPass.controls['Password'].invalid && (resetPass.controls['Password'].dirty || resetPass.controls['Password'].touched) "
                                class="alert alert-danger" style="height: 30px; margin-top: 10px;">
                                <div *ngIf="resetPass.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="passerror && resetPass.controls['Password'].valid  " class="alert alert-danger">
                                <div>
                                    Enter Valid Password
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5"><i>Note:&nbsp;Password should
                                    contain atleast 8
                                    characters/
                                    digits includes 1 special character, 1 lower and uppercase characters
                                </i></label>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="!resetPass.valid ||passerror" id="ATListDeleteATT"
                    (click)="DeleteATT(deleteList)">Delete</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal" id="ATListCanDel"
                    (click)="CancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span id="OpenNotesModal" data-bs-target="#shownotes" data-bs-toggle="modal"></span>
<div class="modal fade" id="shownotes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">

    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Notes</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal" id="ATListnotes"></button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">
                    <div class="col-lg-12">
                        <textarea class="form-control" style="max-width: 430px;height: 72px;" [(ngModel)]="ATNotes">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" id="ATListUpdateAdminTimeNotes"
                    [disabled]="ATNotes==null || ATNotes==undefined || ATNotes==''"
                    (click)="UpdateAdminTimeNotes()">Save</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal" id="ATListUpdateAdminTimeNotesbtn">Close</button>
            </div>
        </div>
    </div>
</div>